export const MOLD_TYPE = {
  MOLD_RECEIVING: 'MOLD_RECEIVING',
  MOLD_MAINTENANCE: 'MOLD_MAINTENANCE',
  MOLD_RELEASE: 'MOLD_RELEASE',
  WEBCAM_CAPTURED_IMAGE :'WEBCAM_CAPTURED_IMAGE',
};

export const MOLD_RELEASE = {
  OPEN_ONE: 'OPEN_ONE',
  OPEN_TWO: 'OPEN_TWO',
  OPEN_THREE: 'OPEN_THREE',
  OPEN_FOUR: 'OPEN_FOUR',
  PICTURE_ONE: 'PICTURE_ONE',
  PICTURE_TWO: 'PICTURE_TWO',
  PICTURE_THREE: 'PICTURE_THREE',
  PICTURE_FOUR: 'PICTURE_FOUR',
  LOADED_ONE: 'LOADED_ONE',
  LOADED_TWO: 'LOADED_TWO',
  BOL_SIGNED_COPY: 'BOL_SIGNED_COPY',
  PACKING_SLIP_SIGNED_COPY: 'PACKING_SLIP_SIGNED_COPY',
};

export const MOLD_MAINTENANCE = {
  MAINTENANCE_REPORT_DOCUMENT: 'MAINTENANCE_REPORT_DOCUMENT',
  INSPECTION_CHECKLIST_DOCUMENT: 'INSPECTION_CHECKLIST_DOCUMENT',
  FUNCTIONAL_TEST_RESULTS_DOCUMENT: 'FUNCTIONAL_TEST_RESULTS_DOCUMENT',
  MOLD_PICTURE_BEFORE_MAINTENANCE: 'MOLD_PICTURE_BEFORE_MAINTENANCE',
  MOLD_PICTURE_AFTER_MAINTENANCE: 'MOLD_PICTURE_AFTER_MAINTENANCE',
  MAINTENANCE_TYPE_PICTURES: 'MAINTENANCE_TYPE_PICTURES',
  REPAIR_PICTURES: 'REPAIR_PICTURES',
  ADDITIONAL_PICTURES: 'ADDITIONAL_PICTURES',
  ADDITIONAL_PICTURE_ONE: 'ADDITIONAL_PICTURE_ONE',
  ADDITIONAL_PICTURE_TWO: 'ADDITIONAL_PICTURE_TWO',
  ADDITIONAL_PICTURE_THREE: 'ADDITIONAL_PICTURE_THREE',
};

export const MOLD_RECEIVING = {
  UPLOAD_PICTURE_OF_DAMAGE: 'UPLOAD_PICTURE_OF_DAMAGE',
  MOLD_DRAWING_ONE: 'MOLD_DRAWING_ONE',
  MOLD_DRAWING_TWO: 'MOLD_DRAWING_TWO',
  MOLD_SPECIFICATIONS_DOCUMENT: 'MOLD_SPECIFICATIONS_DOCUMENT',
  PREVIOUS_MAINTENANCE_RECORDS: 'PREVIOUS_MAINTENANCE_RECORDS',
  MOLD_PICTURE_ON_THE_TRAILER: 'MOLD_PICTURE_ON_THE_TRAILER',
  MOLD_PICTURE_UNLOADED: 'MOLD_PICTURE_UNLOADED',
  MOLD_PICTURE_OPEN: 'MOLD_PICTURE_OPEN',
  ADDITIONAL_PICTURES_ONE: 'ADDITIONAL_PICTURES_ONE',
  ADDITIONAL_PICTURES_TWO: 'ADDITIONAL_PICTURES_TWO',
  ADDITIONAL_PICTURES_THREE: 'ADDITIONAL_PICTURES_THREE',
  ADDITIONAL_PICTURES_FOUR: 'ADDITIONAL_PICTURES_FOUR',
  ADDITIONAL_PICTURES_FIVE: 'ADDITIONAL_PICTURES_FIVE',
  ADDITIONAL_PICTURES_SIX: 'ADDITIONAL_PICTURES_SIX',
  FUNCTIONAL_TEST: 'FUNCTIONAL_TEST',
};
